import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'pleaseWaitButton',
  templateUrl: './please-wait-button.component.html'
})
export class PleaseWaitButtonComponent {
  @Input() isWaiting: boolean;
  @Input() title: string;
  @Input() classes: string;
  @Input() gtmData: string;
  @Output() unblockedClick = new EventEmitter();

  public emitUnblockedClick(event) {
    this.unblockedClick.emit(event);
  }
}
